import { gql } from '@apollo/client'

export const SEND_EMAIL_MUTATION = gql`
    mutation SendEmail($input: EmailInput!) {
        sendEmail(input: $input) {
            success
        }
    }
`
